import {combineReducers} from 'redux'
import createProjectReducer from './project/reducer'
import createCustomerReducer from './customer/reducer'
import user from './user/reducer'
import createTaskReducer from './task/reducer'

export default (initAppData) => combineReducers({
    task: createTaskReducer(initAppData),
    project: createProjectReducer(initAppData),
    customer: createCustomerReducer(initAppData),
    user
})


// WEBPACK FOOTER //
// ./web/js/panels/reducer.js